import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "button"]

  connect() {
  }

  copy() {

    const text = this.textareaTarget.value

    navigator.clipboard.writeText(text).then(() => {
      this.showFeedback('success')
    }).catch((error) => {
      this.showFeedback('error')
    })
  }

  showFeedback(type) {
    if (!this.hasButtonTarget) return

    const button = this.buttonTarget
    const svg = button.querySelector('svg')

    // 既存の色クラスを削除して新しい色を追加
    button.classList.remove('text-gray-700', 'hover:text-gray-900', 'text-green-600', 'text-red-600', 'text-yellow-600')

    // 元のSVGを保存
    if (!this.originalSvg) {
      this.originalSvg = svg.outerHTML
    }

    // アイコンと色を変更
    switch (type) {
      case 'success':
        button.classList.add('text-green-600')
        // チェックマークアイコンに変更
        svg.outerHTML = `
          <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
        `
        break
      case 'error':
        button.classList.add('text-red-600')
        break
    }

    // 1.5秒後にアイコンと色を元に戻す
    setTimeout(() => {
      if (this.originalSvg) {
        const currentSvg = button.querySelector('svg')
        currentSvg.outerHTML = this.originalSvg
      }
      button.classList.remove('text-green-600', 'text-red-600', 'text-yellow-600')
      button.classList.add('text-gray-700', 'hover:text-gray-900')
    }, 1500)
  }
}